import { ButtonProps, Button as ChakraButton } from '@chakra-ui/react'

interface iButtonProps extends ButtonProps{
  VarColor?: string
  Hover?: any
}
export const Button: React.FC<iButtonProps> = ({ VarColor, Hover, children, ...rest }) => {
  return (
        <ChakraButton
            {...rest}
            borderRadius={'12px'}
            filter='auto'
            _hover={Hover ?? {
              bg: VarColor && `var(--${VarColor}-hover)`,
              boxShadow: 'var(--SombraBtns)',
              transition: 'var(--transitionBtns);'
            }}
            bg={VarColor && `var(--${VarColor})`
        }>{children}</ChakraButton>
  )
}
